import { Provider } from "@angular/core";
import { MessageService } from "primeng/api";
import { ToastService } from "./message.config";

export function provideMessage(): Provider[] {
  return [MessageService, ToastService];
}

export * from "./service/toast.service";
